export default "Two devlogs, one year apart.";